if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.prevButton = this.querySelector('.product-media-modal__button--prev');
        this.nextButton = this.querySelector('.product-media-modal__button--next');
        this.container = this.querySelector('[role="document"]');

        if (this.prevButton) {
          this.prevButton.addEventListener('click', () => {
            if (this.container) {
              this.container.scrollBy({ left: -this.container.clientWidth, behavior: 'smooth' });
            }
          });
        }
        if (this.nextButton) {
          this.nextButton.addEventListener('click', () => {
            if (this.container) {
              this.container.scrollBy({ left: this.container.clientWidth, behavior: 'smooth' });
            }
          });
        }

        this.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.prevButton && this.prevButton.click();
          } else if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.nextButton && this.nextButton.click();
          }
        });

        // Click listeners on thumbnails
        this.querySelectorAll('.product-media-modal__thumbnail').forEach((thumb) => {
          thumb.addEventListener('click', (event) => {
            event.stopPropagation();
            const mediaId = thumb.getAttribute('data-media-id');
            const targetSlide = this.container.querySelector(`[data-media-id="${mediaId}"]`);
            if (targetSlide) {
              targetSlide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
              
              const activeMediaTemplate = targetSlide.querySelector('template');
              const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
              if (
                targetSlide.nodeName == 'DEFERRED-MEDIA' &&
                activeMediaContent &&
                activeMediaContent.querySelector('.js-youtube')
              ) {
                targetSlide.loadContent();
              }
            }
          });
        });

        // Listen for scroll events on slides container to update active thumbnail
        if (this.container) {
          this.container.addEventListener('scroll', () => {
            if (this.scrollTimeout) clearTimeout(this.scrollTimeout);
            this.scrollTimeout = setTimeout(() => {
              this.updateActiveThumbnail();
            }, 100);
          });
        }
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        setTimeout(() => {
          activeMedia.scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'center' });
          this.updateActiveThumbnail();
        }, 50);

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      updateActiveThumbnail() {
        if (!this.container) return;
        const scrollLeft = this.container.scrollLeft;
        const width = this.container.clientWidth;
        if (width === 0) return;
        const activeIndex = Math.round(scrollLeft / width);

        // Find visible slides
        const slides = Array.from(this.container.children).filter(el => {
          return window.getComputedStyle(el).display !== 'none';
        });

        const activeSlide = slides[activeIndex];
        if (!activeSlide) return;

        const activeMediaId = activeSlide.getAttribute('data-media-id');

        this.querySelectorAll('.product-media-modal__thumbnail').forEach((thumb) => {
          if (thumb.getAttribute('data-media-id') === activeMediaId) {
            thumb.classList.add('active');
            thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          } else {
            thumb.classList.remove('active');
          }
        });
      }
    }
  );
}
